module.exports = __webpack_public_path__ + "img/5.5e0227bf.jpg";